export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/AllowLocation.39d6d0b5.svg","height":248,"width":375,"blurWidth":0,"blurHeight":0};